import getCorePopUpStore from "../../../stores/core/core-popup-store";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import Et3Margin from "../../et3-ui/ET3Margin";
import CopyPopUpButton from "./copy-pop-up-button";
import AlertPopupHeader from "./alert-pop-up-header";
import OKPopUpBottun from "./ok-pop-up-bottun";

const AlertPopUp = withLiteObserverAndTheme<{ width: number }>((props) => {
  const { theme, width } = props;
  const { colors, unitY } = theme;
  const finalMessage = getCorePopUpStore().getFinalMessage();
  const action = getCorePopUpStore().alertAction.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={width}
      height={1080}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 10
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={true}
        width={1000}
        height={0}
        color={colors.all.white}
        style={{
          position: "relative",
          borderRadius: 50,
          zIndex: 5,
          overflow: "hidden"
        }}
        onClick={() => {}}
      >
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <AlertPopupHeader />
        <Et3Margin top={30} bottom={30} left={0} right={0} />
        <ET3Div
          isScrollable={true}
          isExtendable={true}
          fDirection="row"
          justifyContent="center"
          alignItems="flex-start"
          withShadow={false}
          width={900}
          height={80}
          color={colors.all.transparent}
          style={{
            maxHeight: 400 * unitY,
            whiteSpace: "pre-wrap"
          }}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={40}
            isSpan={false}
            text={finalMessage}
            color={colors.all.black}
            style={{
              lineHeight: 1
            }}
          />
        </ET3Div>
        <Et3Margin top={30} bottom={30} left={0} right={0} />
        {action === "COPY" ? <CopyPopUpButton /> : <OKPopUpBottun />}
      </ET3Div>
    </ET3Div>
  );
});

export default AlertPopUp;
